export default __webpack_public_path__ + "static/corners-dont-9f74b4ed9e26c85354f0cbaa8cf8013f.png";